import { render } from "./AdminCobrancasView.vue?vue&type=template&id=3d6be545&scoped=true"
import script from "./AdminCobrancasView.vue?vue&type=script&lang=js"
export * from "./AdminCobrancasView.vue?vue&type=script&lang=js"

import "./AdminCobrancasView.vue?vue&type=style&index=0&id=3d6be545&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6be545"]])

export default __exports__